export default __webpack_public_path__ + "static/media/guardian_white_icon.b076e491.png";